const clearItems = items => items.map(item => ({
  ...item,
  checked: false,
  indeterminate: false,
  open: false,
  children: item.children && clearItems(item.children),
}));

export default clearItems;
